import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './i18n' // Import i18n configuration
import ErrorBoundary from './components/ErrorBoundary'
// import serviceWorkerManager from './utils/serviceWorker.js' // Service Worker disabled - caching removed

// Service Worker and PWA features disabled
// serviceWorkerManager.register()
// serviceWorkerManager.handleInstallPrompt()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)